/**
 * Authoring tab — lesson list + new-lesson stub.
 *
 * Placeholder content. The real lesson-authoring CSG editor lands later;
 * this just gives the dashboard a stable shape to navigate around.
 */
export function AuthoringTab(): JSX.Element {
  return (
    <div>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Lessons</h1>
          <p className="mt-1 text-sm text-slate-600">
            Build a chain of challenges your class will work through.
          </p>
        </div>
        <button
          type="button"
          disabled
          className="min-h-[48px] rounded-2xl bg-amber-500 px-5 py-3 text-sm font-semibold text-white shadow transition disabled:cursor-not-allowed disabled:opacity-60"
          title="Coming soon"
        >
          + New lesson
        </button>
      </div>

      <div className="mt-8 rounded-2xl border-2 border-dashed border-amber-200 bg-white p-10 text-center">
        <p className="text-sm text-slate-500">
          No lessons yet. The authoring tool is on the way — for now this is a placeholder.
        </p>
      </div>
    </div>
  );
}
